var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Work_Experience",
    "data-name": "Work Experience",
    d: "M16.444,2.829H13.6V1.654A1.647,1.647,0,0,0,11.965,0H6.056A1.649,1.649,0,0,0,4.415,1.654V2.829H1.556A1.565,1.565,0,0,0,0,4.4v2.53A2.261,2.261,0,0,0,.709,8.539v5.892A1.565,1.565,0,0,0,2.266,16H15.734a1.565,1.565,0,0,0,1.556-1.569V8.539A2.285,2.285,0,0,0,18,6.917V4.387a1.565,1.565,0,0,0-1.556-1.569ZM5.411,1.654a.64.64,0,0,1,.635-.64h5.908a.64.64,0,0,1,.635.64V2.829H5.411V1.654ZM1,4.4a.567.567,0,0,1,.561-.566H16.444A.567.567,0,0,1,17,4.4v2.53c0,1.334-2.52,2.412-6.194,2.7V9.1a.5.5,0,0,0-.5-.5h-2.6a.5.5,0,0,0-.5.5v.523C3.547,9.35,1.016,8.262,1.016,6.938V4.408ZM9.8,9.6v.726a.724.724,0,0,1-.72.726H8.9a.724.724,0,0,1-.72-.726V9.6H9.794ZM16.3,14.431a.567.567,0,0,1-.561.566H2.266a.567.567,0,0,1-.561-.566V9.276a14.137,14.137,0,0,0,5.516,1.356A1.719,1.719,0,0,0,8.9,12.051h.18a1.729,1.729,0,0,0,1.684-1.42,14.089,14.089,0,0,0,5.516-1.356v5.155Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkExperience);
export default __webpack_public_path__ + "static/media/WorkExperience.bc9a01bf88dad8bdf3e322630bec8a2d.svg";
export { ForwardRef as ReactComponent };